import React, { useState, useEffect } from "react";
import { Input } from "@boulevard/blvd-ui";

const formatAsDollars = (num: Cents): string =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2
  }).format(num / 100);

type Cents = number;

export type CurrencyInputProps = Partial<typeof Input> & {
  value: Cents;
  onBlur(newVal: Cents): void;
  onFocus?: (e: React.FormEvent<HTMLInputElement>) => void;
};

function CurrencyInput({
  value,
  onBlur,
  onFocus
}: CurrencyInputProps): JSX.Element {
  const [internalVal, setInternalVal] = useState<string>(
    formatAsDollars(value)
  );

  useEffect(() => {
    setInternalVal(formatAsDollars(value));
  }, [value]);

  return (
    <Input
      prefix="$"
      type="text"
      value={internalVal}
      width={90}
      size="small"
      alignText="right"
      onFocus={onFocus}
      onChange={(e: React.FormEvent<HTMLInputElement>): void => {
        if (e.currentTarget.value.match(/^\d*\.?\d*$/g)) {
          setInternalVal(e.currentTarget.value);
        }
      }}
      onBlur={(e: React.FormEvent<HTMLInputElement>): void => {
        onBlur(Math.round(Number(e.currentTarget.value) * 100));
      }}
    />
  );
}

export default CurrencyInput;
